import { __rest } from "tslib";
import * as React from 'react';
const NotificationsFill = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M17.99 14.437l1.798 2.475a.996.996 0 01.083 1.041.996.996 0 01-.892.547H5a.995.995 0 01-.89-.547.996.996 0 01.081-1.041l1.8-2.475v-3.942A5.964 5.964 0 019.88 4.88 2.131 2.131 0 0111.99 3c1.084 0 1.982.821 2.11 1.879a5.964 5.964 0 013.89 5.616v3.942zM9.699 19.5A2.503 2.503 0 0011.99 21a2.504 2.504 0 002.292-1.5H9.699z" })));
};
NotificationsFill.displayName = 'NotificationsFill';
export default NotificationsFill;
//# sourceMappingURL=NotificationsFill.js.map